/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateVSTSVerificationKeyInput = {
    currentUrl?: string | null | undefined;
    vstsAccount?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createVstsVerificationKeyMutationVariables = {
    input: CreateVSTSVerificationKeyInput;
};
export type createVstsVerificationKeyMutationResponse = {
    readonly createVSTSVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type createVstsVerificationKeyMutation = {
    readonly response: createVstsVerificationKeyMutationResponse;
    readonly variables: createVstsVerificationKeyMutationVariables;
};



/*
mutation createVstsVerificationKeyMutation(
  $input: CreateVSTSVerificationKeyInput!
) {
  createVSTSVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateVSTSVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateVSTSVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createVSTSVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createVstsVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createVstsVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createVstsVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createVstsVerificationKeyMutation(\n  $input: CreateVSTSVerificationKeyInput!\n) {\n  createVSTSVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '0ebd0b288edc07bb2198edb57a51707b';
export default node;
